module.exports = __webpack_public_path__ + "media/images/icons/ic_arrowup_24-ca6fc13eb1c36c5eb1b49454032073c5.svg";